<template>
  <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="48" cy="48" r="48" fill="#7982AD" fill-opacity="0.1"/>
  <path d="M39.3345 35.4067C39.3345 34.0559 40.8116 33.2247 41.9661 33.9257L64.8615 47.8265C65.3885 48.1465 65.3885 48.9113 64.8615 49.2312L41.9661 63.132C40.8116 63.833 39.3345 63.0018 39.3345 61.6511V35.4067Z" fill="white" stroke="#ADBACC" stroke-width="2"/>
  <rect opacity="0.5" x="27.7588" y="39.0109" width="6.34517" height="20.093" rx="3.17258" fill="#ADBACC"/>
  </svg>
</template>

<script>
export default {
  name:"NoAccountLinked"
}
</script>